export default {
    enterPackageName: "Введите название пакета",
    enterPackagePrice: "Введите цену пакета",
    addPackage: "Добавить пакет",
    PackageDetails: "Подробности пакета",
    DataUsage: "Трафик",
    Expiration: "Срок действия",
    Model: "Модель",
    Enable: "Включить",
    Disable: "Выключить",
    PackageName: "Название пакета",
    PackagePrice: "Цена пакета",
    PackageStatus: "Статус пакета",
    PackageType: "Тип пакета",
    audience: "Объект пакета",
    PackageUnit: "Единица пакета",
    Quantity: "Количество",
    UpdateDate: "Дата обновления",
    Day: "день",
    Month: "месяц",
    Year: "год",
    day: "дн.",
    Item: "шт.",
    nameCannot: "Название пакета не может быть пустым",
    priceCannot: "Цена пакета не может быть пустой",
    Associated: "Связанная организация",
    Tariff: "Список тарифных пакетов",
    Yuan: "руб.",
    newPackage: "Новый пакет",
    deletedPackageSuc: "Пакет удалён",
    deletedPackageErr: "Не удалось удалить пакет",
    ModifyPackage: "Изменить пакет",
    addedPackage: "Пакет успешно добавлен",
    FailedAddPackage: "Не удалось добавить пакет",
    modifiedPackage: "Пакет успешно изменён",
    modifyFailed: "Не удалось изменить пакет",
    confirmDelPackage: "Удалить этот пакет?",
    correctPrice: "Введите корректную цену",
    noZero: "Цена пакета не может быть 0",
    numNoZero: "Количество пакетов не может быть 0",
    selectedDevice: "Просмотр выбранных устройств",
    Associateddevice: "Связанные устройства",
    thisDevice: "Связать тариф с этим устройством?",
    canceldevice: "Отменить связь тарифа с этим устройством?",
    UnselectDevice: "Снять выбор с устройства?",
    selectdeviceFirst: "Сначала выберите устройство",
    Deviceselected: "Выбранные устройства",
    Associatedselected: "Выбранные связанные устройства",
    modelList: "Список моделей",
    ViewDeviceM: "Просмотр выбранных моделей",
    AssociatedDevice: "Связанные модели",
    associateDevice: "Связать тариф с этой моделью?",
    cancelAssociation: "Отменить связь тарифа с этой моделью?",
    selectModel: "Сначала выберите модель",
    selectDevice: "Выбранные модели",
    associatedModel: "Сначала выберите связанную модель",
    AssociatedSelected: "Выбранные связанные модели",
    cancelSelectModel: "Снять выбор с модели?",
    uList: "Список организаций",
    viewSeleteU: "Просмотр выбранных организаций",
    glUnit: "Связанные организации",
    enterUName: "Введите название организации",
    sureAssociatU: "Связать тариф с этой организацией?",
    cancelAssociatU: "Отменить связь тарифа с этой организацией?",
    cancelSelectU: "Снять выбор с организации?",
    selectU: "Сначала выберите организацию",
    selectedU: "Выбранные организации",
    selectAssociaU: "Сначала выберите связанную организацию",
    selectedAssociaU: "Выбранные связанные организации",
    viewSelectedUser: "Просмотр выбранных пользователей",
    gledUser: "Связанные пользователи",
    gledUserTips: "Связать тариф с этим пользователем?",
    cancelGLU: "Отменить связь тарифа с этим пользователем?",
    loginName: "Имя входа",
    cancelSelectUser: "Снять выбор с пользователя?",
    selectUser: "Сначала выберите пользователя",
    selectedUser: "Выбранные пользователи",
    glSelectUser: "Сначала выберите связанного пользователя",
    glSelectedUser: "Выбранные связанные пользователи",
    inputON: "Введите номер заказа",
    orderN: "Номер заказа",
    orderState: "Статус заказа",
    orderPrice: "Сумма заказа",
    orderNum: "Количество",
    upDate: "Дата изменения",
    pay: "Оплата",
    orderInfo: "Информация о заказе",
    orderGLD: "Устройства заказа",
    payPhoto: "Информация снимка оплаты",
    packageInfo: "Информация о пакете",
    orderName: "Название заказа",
    submitPay: "Подтвердить оплату",
    wx_sweep: "Отсканируйте код WeChat",
    payEnd: "Транзакция завершена",
    paying: "Транзакция выполняется",
    packageId: "ID пакета",
    orderNO: "Номер заказа",
    payInfo: "Информация до покупки",
    payedInfo: "Информация после покупки",
    clearSearch: "Условия поиска очищены",
    paySnapshot: "Снимок оплаты",
    PackageList: "Список пакетов",
    RefreshPackages: "Обновить пакеты",
    Price: "Цена",
    Enabled: "Включён",
    Disabled: "Выключен",
    SelectDate: "Выберите дату окончания",
    AddQueue: "Добавить в очередь к оплате",
    QueueList: "Список к оплате",
    OrderCode: "Код заказа",
    ClearQueue: "Очистить список к оплате",
    SubmitOrder: "Оформить заказ",
    enterQuantity: "Введите количество пакетов",
    enterInteger: "Введите целое положительное число",
    SelectedPackages: "Выбранные пакеты",
    SelectPackage: "Выберите пакет",
    NoAvailable: "Нет доступных пакетов",
    enterNumber: "Введите число",
    Payment: "Оплата",
    toShoppingCart: "Удалить устройство из корзины?",
    quantityEmpty: "Количество пакетов не может быть пустым",
    Expired: "Истёк",
    ExpiringSoon7: "Скоро истекает (7 дней)",
    ExpiringSoon30: "Скоро истекает (30 дней)",
    operationContinue: "Список к оплате будет очищен. Продолжить?",
    clearedSucc: "Список к оплате очищен",
    FailedQueue: "Не удалось очистить список к оплате",
    SelectShopCart: "Выберите устройства для добавления в корзину",
    DeviceID: "Номер",
    FailedAddCart: "Не удалось добавить устройство в корзину",
    shopAddedSucce: "Добавлено в корзину",
    TDYHNBATTSC: "Устройство не в корзине. Добавить в корзину?",
    NPSUTSO: "Пакет не выбран. Невозможно оформить заказ.",
    PLIEUTSO: "Список к оплате пуст. Невозможно оформить заказ.",
    billDevice: "Добавить выбранные устройства в список к оплате?",
    price500: "Цена пакета не может превышать 500",
    Pleaseenter: "Введите",
    PaymentTime: "Время оплаты",
    PaySnapshotD: "Подробности снимка оплаты",

    enterOrderNumber: "Введите номер заказа",
    enterOpenid: "Введите openid",
    selectTradingType: "Выберите тип транзакции",
    selectTradingStatus: "Выберите статус транзакции",
    OfficialPayment: "Оплата в официальном аккаунте",
    Apppayment: "Оплата в приложении",
    QRCodePayment: "Оплата по QR-коду",
    H5Payment: "H5-оплата",
    FacePayment: "Оплата по лицу",
    PaymentSucc: "Оплата успешна",
    Refundinitiat: "Возврат",
    NotPaid: "Не оплачено",
    Closed: "Закрыто",
    Cancelled: "Отменено",
    UserPaying: "Ожидание оплаты пользователем",
    PaymentFailed: "Оплата не удалась",
    MerchantID: "Номер мерчанта",
    WeChatOrder: "Номер заказа WeChat",
    BankType: "Тип банка",
    OrderCurrency: "Валюта заказа",
    MerchantNumber: "Внутренний номер заказа мерчанта",
    UserOpenid: "Openid пользователя",
    PaymentCurrency: "Валюта оплаты",
    UserAmount: "Сумма оплаты пользователя",
    CallbackSummary: "Сводка ответа",
    TransactionType: "Тип транзакции",
    TransactionStatus: "Статус транзакции",
    TotalAmount: "Общая сумма заказа",
    statusDescri: "Описание статуса транзакции",
    transactionTime: "Время успешной транзакции",
    scanPay: "Оплата по коду",
    RMB: "Юань",
    createOrder: "Создать заказ",
    forbiddenPackage: "Пакет отключён",
    orderDetail: "Подробности заказа",
}
